module.exports = __webpack_public_path__ + "static/greystartaggie-5a7c474932bb61d8adabb4c96c0cc6ba.png";